export const taskReportsData = [
  {
    taskName: "Add a form to Update Task",
    assignedTo: "Adrian Davies",
    priority: "High",
    dueDate: "25 Sep 2023",
    type: "Calls",
    status: "Inprogress",
    createdDate: "25 Sep 2023, 01:22 pm",
    key: "1"
  },
  {
    taskName: "Make all strokes thinner",
    assignedTo: "Adrian Davies",
    priority: "Medium",
    dueDate: "29 Sep 2023",
    type: "Meeting",
    status: "Completed",
    createdDate: "29 Sep 2023, 04:15 pm",
    key: "2"
  },
  {
    taskName: "Update orginal contentuelysell",
    assignedTo: "Adrian Davies",
    priority: "High",
    dueDate: "05 Oct 2023",
    type: "Email",
    status: "Inprogress",
    createdDate: "04 Oct 2023, 10:18 am",
    key: "3"
  },
  {
    taskName: "Use only component colours",
    assignedTo: "Adrian Davies",
    priority: "Medium",
    dueDate: "14 Oct 2023",
    type: "Meeting",
    status: "Completed",
    createdDate: "17 Oct 2023, 03:31 pm",
    key: "4"
  },
  {
    taskName: "Add images to the cards section",
    assignedTo: "Adrian Davies",
    priority: "Low",
    dueDate: "15 Nov 2023",
    type: "Task",
    status: "Inprogress",
    createdDate: "24 Oct 2023, 09:14 pm",
    key: "5"
  },
  {
    taskName: "Design description banner & landing page",
    assignedTo: "Adrian Davies",
    priority: "High",
    dueDate: "25 Nov 2023",
    type: "Calls",
    status: "Completed",
    createdDate: "08 Nov 2023, 09:56 am",
    key: "6"
  },
  {
    taskName: "Make sure all the padding should be 24px",
    assignedTo: "Adrian Davies",
    priority: "Low",
    dueDate: "08 Dec 2023",
    type: "Email",
    status: "Completed",
    createdDate: "14 Nov 2023, 04:19 pm",
    key: "7"
  },
  {
    taskName: "Use border radius as 5px or 10 px",
    assignedTo: "Adrian Davies",
    priority: "Medium",
    dueDate: "21 Dec 2023",
    type: "Task",
    status: "Completed",
    createdDate: "23 Nov 2023, 11:14 pm",
    key: "8"
  },
  {
    taskName: "Use Grey scale colors as body color",
    assignedTo: "Adrian Davies",
    priority: "Medium",
    dueDate: "21 Dec 2023",
    type: "Meeting",
    status: "Inprogress",
    createdDate: "10 Dec 2023, 06:43 am",
    key: "9"
  },
];
